import Component from '../../core/Component';
import { KV } from './../../core/Constant';
import { PlayerEvent } from '../../PlayerEvents';
import { mergeOptions, isObject } from '../../utils/util';
import log from 'loglevel';

let defaultSwf =
  process.env.NODE_ENV === 'production'
    ? 'https://static.vhallyun.com/jssdk/vhall-jssdk-player/latest/swf/video-js.swf'
    : 'https://t-static01-open.e.vhall.com/jssdk/vhall-jssdk-player/latest/swf/video-js.swf';

/**
 * @export
 * @class flash
 * @extends { Component }
 */
export default class Flash extends Component {
  constructor(opt) {
    super(opt);
    this._swf = undefined;
    this._setSrcCount = 0;
    this._countSwf = 0;
    this._config = opt;
    this._root = null;
    this.isSetSrc = false;
    this.isReady = false;
    this._newUrl = '';
    this._oldUrl = '';
    this._src = '';
    this.flash = null;
    this._isLive = false;
    this._isPlaying = false;
    this._store = null;
    this._volume = 0.5;
    // 点播已播完
    this._ended = false;
    this.TAG = 'FlashPlayer';
    this._type = 'FlashPlayer';
    // 由于swf抛出的durationchange事件不规律,所以另外用定时器来抛出timeupdate事件
    this.timeId = setInterval(() => {
      let e = {};
      e.target = this.flash;
      e.target.currentTime = this.getCurrentTime();
      if (this._isPlaying) {
        if (this.vodPlayedTime && e.target.currentTime < 1) {
          return;
        }
        // 直播时发起端与观看端的延时
        if (this._isLive) {
          const buffered = this.getBuffered();
          const currentTime = e.target.currentTime;
          const bufferedLen = buffered.length;
          const buffer = bufferedLen >= 1 ? buffered[0][1] : 0;
          // 计算时差
          let delay = buffer - currentTime;
          // 为避免部分手机老旧浏览器兼容性问题，导致计算错误。故加判断2020.03.12
          delay = delay < 120 ? delay : 10;
          // 链路延时+1.5s
          delay += 1.5;
          if (this._owner.currentDefinition.def !== 'same') {
            // 转码延时+2s，这有个坑。如果转码目标分辨率与原画分辨率一致，则后端转码直接拷贝无延时。但目前播放器无法判断。
            delay += 2;
          }
          // 避免传入负值
          delay = delay < 0 ? 0 : delay;
          e.delay = delay;
        }
        this.emit2All(PlayerEvent.TIMEUPDATE, e);
        this.vodPlayedTime = undefined;
      }
    }, 100);
  }

  onSWFReady(pObjectID) {
    this.isReady = true;
    if (this._newUrl && !this.isSetSrc && this.isFlag) {
      this.setSource(this._newUrl);
    }
  }

  onSWFEvent(swfID, eventName) {
    log.info(`捕获swf事件 swfID=${swfID}, eventName=${eventName}`);
    switch (eventName) {
      case 'ended':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        if (!this._isLive) {
          // 点播播完了 ended
          this.emit2All(PlayerEvent.ENDED);
          this._ended = true;
          // 点播MP4播完后循环
          if (this._config.type === 'native' && !this._isLive) {
            const isLoop = this.flash.vjs_getProperty('loop');
            if (isLoop) {
              log.info('mp4已播完，循环播放');
              this._ended = false;
              this.flash.vjs_setProperty('currentTime', 0);
              this.flash.vjs_play();
              this.emit2All(PlayerEvent.TOUCH_PLAY);
            }
          }
        }
        if (this._isLive && this._config.type === 'flv') {
          // flv直播 断流后要抛错,判断卡顿也停了
          const e = {
            type: 'mediaError',
            details: 'streamnotfound'
          };
          this.emit2All(PlayerEvent.ERROR, e);
          clearTimeout(this._timeId3);
          this._timeId3 = setTimeout(() => {
            // 拉流重试
            const baseUrl = this._oldUrl.split('?')[0];
            const newToken = this._owner.newToken;
            const url = `${baseUrl}?token=${newToken}`;
            this.setSource(url);
          }, 3000);
        }
        break;
      case '#HLS# : M3U8 detected!':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // IE直播hls，设置不自动播放时，在播放状态切线后需要手动设置播放
        if (
          this._isLive &&
          this._config.type === 'hls' &&
          this._setSrcCount > 1 &&
          !this.getAutoplay() &&
          this._beforePlayState
        ) {
          setTimeout(() => {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }, 500);
        }
        break;
      case 'onsrcchange':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // 点播mp4设置不自动播放时，在播放状态换线后需要手动播放，只能在onsrcchange事件后设置播放(若是立即设置播放会卡顿一直切线，故0.5s后设置)
        if (
          !this._isLive &&
          !this.getAutoplay() &&
          this._setSrcCount > 1 &&
          this._config.type === 'native' &&
          this._beforePlayState
        ) {
          setTimeout(() => {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }, 500);
        }
        // rtmp直播在播放状态换清晰度时需手动设置播放, 需在onsrcchange事件后，不能立即设置
        if (this._isLive && this._config.type === 'rtmp' && this.isChangeDefinition && this._isPlaying) {
          this.isChangeDefinition = null;
          setTimeout(() => {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }, 500);
        }
        // IE直播flv，设置不自动播放时，在播放状态切线后需要手动播放
        if (
          this._isLive &&
          this._config.type === 'flv' &&
          this.isChangeDefinition &&
          !this.getAutoplay() &&
          this._beforePlayState
        ) {
          this.isChangeDefinition = null;
          setTimeout(() => {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }, 500);
        }
        break;
      case 'loadstart':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        break;
      case 'loadedmetadata':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // loadedmetadata事件
        this.emit2All(PlayerEvent.LOADEDMETADATA);
        break;
      case 'loadeddata':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        if (!this.loadeddata) {
          this.loadeddata = true;
          this.emit2All(PlayerEvent.LOADED);
        }
        break;
      case 'play':
        const networkState1 = this.flash.vjs_getProperty('networkState');
        const readyState1 = this.flash.vjs_getProperty('readyState');
        const currentTime1 = this.flash.vjs_getProperty('currentTime');
        log.info(`networkState=${networkState1}  readyState=${readyState1}  currentTime=${currentTime1}`);
        // rtmp
        if (
          currentTime1 > 0 &&
          !this._isPlaying &&
          (this.getAutoplay() || (!this.getAutoplay() && this._clickPlaying))
        ) {
          this._isPlaying = true;
          this.emit2All(PlayerEvent.PLAY);
        }
        this.emit2All(PlayerEvent.PLAYING); //hls，rtmp，flv统一增加playing事件
        break;
      case 'canplay':
        const networkState2 = this.flash.vjs_getProperty('networkState');
        const readyState2 = this.flash.vjs_getProperty('readyState');
        const currentTime2 = this.flash.vjs_getProperty('currentTime');
        log.info(`networkState=${networkState2}  readyState=${readyState2}  currentTime=${currentTime2}`);
        // hls抛play事件
        if (
          (readyState2 === 2 || readyState2 === 3 || readyState2 === 4) &&
          !this._isPlaying &&
          (this.getAutoplay() || (!this.getAutoplay() && this._clickPlaying))
        ) {
          this._isPlaying = true;
          this.emit2All(PlayerEvent.PLAY);
        }
        break;
      case 'playing':
        // 注意：hls不抛playing事件
        const networkState3 = this.flash.vjs_getProperty('networkState');
        const readyState3 = this.flash.vjs_getProperty('readyState');
        const currentTime3 = this.flash.vjs_getProperty('currentTime');
        log.info(`networkState=${networkState3}  readyState=${readyState3}  currentTime=${currentTime3}`);
        if (
          !this._isLive &&
          this.isChangeDefinition &&
          this._config.type === 'native' &&
          (readyState3 === 2 || readyState3 === 3 || readyState3 === 4)
        ) {
          // 点播mp4,从已播位置开始播
          this.flash.vjs_setProperty('currentTime', this.flashPlayedTime);
          // log.info(`从已播位置播seek(${this.flashPlayedTime})`);
          this.flashPlayedTime = null;
          this.isChangeDefinition = null;
          if (this._beforePlayState) {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }
        }
        // rtmp和flv 抛play事件
        if (
          (readyState3 === 2 || readyState3 === 3 || readyState3 === 4 || currentTime3 >= 0) &&
          !this._isPlaying &&
          this.loadeddata &&
          (this.getAutoplay() || (!this.getAutoplay() && this._clickPlaying))
        ) {
          this._isPlaying = true;
          this.emit2All(PlayerEvent.PLAY);
        }
        // 线上环境播flv时readyState=0，currentTime=0也能播放, 没流也抛playing事件
        if (
          this._isLive &&
          this._config.type === 'flv' &&
          !this._isPlaying &&
          this.loadeddata &&
          (this.getAutoplay() || (!this.getAutoplay() && this._clickPlaying))
        ) {
          this._isPlaying = true;
          this.emit2All(PlayerEvent.PLAY);
        }
        break;
      case 'canplaythrough':
        const networkState = this.flash.vjs_getProperty('networkState');
        const readyState = this.flash.vjs_getProperty('readyState');
        const currentTime = this.flash.vjs_getProperty('currentTime');
        log.info(`networkState=${networkState}  readyState=${readyState}  currentTime=${currentTime}`);
        // rtmp 拉流失败抛错重试, 断流抛错重试
        if (this._config.type === 'rtmp' && networkState === 1 && readyState === 0 && isNaN(currentTime)) {
          // 拉不到流时抛出错误
          const e = {
            type: 'mediaError',
            details: 'streamnotfound'
          };
          this.emit2All(PlayerEvent.ERROR, e);
          // 3s后拉流重试
          clearTimeout(this._timeId2);
          this._timeId2 = setTimeout(() => {
            // 拉流重试
            const baseUrl = this._oldUrl.split('?')[0];
            const newToken = this._owner.newToken;
            const url = `${baseUrl}?token=${newToken}`;
            this.setSource(url);
          }, 3000);
        }
        break;
      case 'pause':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // pause事件
        this._isPlaying = false;
        this.emit2All(PlayerEvent.PAUSE);
        break;
      case 'waiting':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // waiting事件
        this.emit2All(PlayerEvent.WAITING);
        break;
      case 'durationchange':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // 点播hls播完后必须在durationchange事件后才开始循环
        if (this._config.type === 'hls' && !this._isLive && this._ended) {
          const isLoop = this.flash.vjs_getProperty('loop');
          if (isLoop) {
            log.info('hls已播完，循环播放');
            this._ended = false;
            this.flash.vjs_setProperty('currentTime', 0);
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }
        }
        break;
      case 'volumechange':
        log.info(`音量=${this.flash.vjs_getProperty('volume')}`);
        this.emit2All(PlayerEvent.VOLUME_CHANGE);
        break;
      case 'levelswitch':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        // 点播hls 切清晰度或卡顿切线时从已播位置开始播。只能在levelswitch事件后设置（不论自动播放是true还是false都可行）
        if (!this._isLive && this._config.type === 'hls' && this.isChangeDefinition) {
          // 点播从已播位置开始播(针对卡顿切线和换清晰度)
          this.flash.vjs_setProperty('currentTime', this.flashPlayedTime);
          // log.info(`从已播位置播seek(${this.flashPlayedTime})`);
          this.flashPlayedTime = null;
          this.isChangeDefinition = null;
          if (this._beforePlayState) {
            this.flash.vjs_play();
            this.emit2All(PlayerEvent.TOUCH_PLAY);
          }
        }
        // IE直播hls，设置不自动播放时，在播放状态换清晰度后需要手动设置播放
        if (
          this._isLive &&
          this._config.type === 'hls' &&
          this.isChangeDefinition &&
          !this.getAutoplay() &&
          this._beforePlayState
        ) {
          this.isChangeDefinition = null;
          this.flash.vjs_play();
          this.emit2All(PlayerEvent.TOUCH_PLAY);
        }
        break;
      case 'seeked':
        log.info(`currentTime=${this.flash.vjs_getProperty('currentTime')}`);
        break;
      default:
        break;
    }
  }

  onSWFErrorEvent(swfID, eventName) {
    log.info(`swf抛错 swfID=${swfID}, ${eventName}`);
    switch (eventName) {
      case 'srcnotfound':
        const e = {
          type: 'mediaError',
          details: 'streamnotfound'
        };
        this.emit2All(PlayerEvent.ERROR, e);
        break;
      case 'rtmpconnectfailure':
        const e1 = {
          type: 'networkError',
          details: 'rtmpConnectFailure'
        };
        this.emit2All(PlayerEvent.ERROR, e1);
        break;
      case 'propertynotfound':
        const e2 = {
          type: 'otherError',
          details: 'propertyNotFound'
        };
        this.emit2All(PlayerEvent.ERROR, e2);
        break;
      default:
        break;
    }
  }

  setSource(url) {
    // 记录换清晰度前的状态
    this._beforePlayState = this._isPlaying;
    // 换清晰度时重置为false
    this._isPlaying = false;
    this.flashPlayedTime = this.getCurrentTime();
    this.vodPlayedTime = this.flashPlayedTime;
    // log.info( `设置播放源url = ${url}`);
    // 当设置不自动播放时
    if (!this.getAutoplay()) {
      this._setSrcCount += 1;
    }
    this._store.setKV(KV.URL, url);
    const e = {
      oldValue: this._oldUrl,
      newValue: url
    };
    this._oldUrl = url;
    this.isSetSrc = true;
    // srcchanged事件
    this.emit2All(PlayerEvent.SRC_CHANGED, e);
    // 重新拉流将标志重置
    this.loadeddata = false;
    if (this._config.type === 'rtmp') {
      // rtmp 直播
      if (this.flash.hasOwnProperty('vjs_setProperty')) {
        const head = url.lastIndexOf('/');
        const domain = url.substring(0, head);
        const stream = url.substring(head + 1);
        this.flash.vjs_stop();
        this.flash.vjs_setProperty('rtmpConnection', domain);
        this.flash.vjs_setProperty('rtmpStream', stream);
      }
    } else {
      // hls直播、flv直播、hls点播、mp4点播
      if (this.flash.hasOwnProperty('vjs_src')) {
        this.flash.vjs_src(url);
      }
    }
  }

  _waitForSWF() {
    log.info(`有属性vjs_setProperty = ${this.flash.hasOwnProperty('vjs_setProperty')}`);
    this._countSwf += 1;
    if (this.flash.hasOwnProperty('vjs_setProperty')) {
      this.flash.vjs_setProperty('eventProxyFunction', 'onSWFEvent');
      this.flash.vjs_setProperty('errorEventProxyFunction', 'onSWFErrorEvent');
      this.isFlag = true;
      if (this._newUrl && !this.isSetSrc && this.isReady) {
        this.setSource(this._newUrl);
      }
    } else {
      log.info(`_countSwf=${this._countSwf}`);
      clearTimeout(this.tId);
      if (this._countSwf > 30) {
        clearTimeout(this.tId);
        this._countSwf = 0;
        this.initFlash(this._config);
      } else {
        this.tId = setTimeout(() => {
          this._waitForSWF();
        }, 10);
      }
    }
  }

  _createSWF(param) {
    let poster = param['poster'] ? { poster: param['poster'] } : {};
    const flashvars = {
      readyFunction: 'onSWFReady',
      eventProxyFunction: 'onSWFEvent',
      errorEventProxyFunction: 'onSWFErrorEvent',
      poster: poster,
      autoplay: param.autoplay || false,
      preload: 'none'
    };

    const params = {
      allowScriptAccess: 'always',
      allowNetworking: 'all',
      wmode: 'opaque',
      bgcolor: '#000000'
    };

    const attributes = {
      id: 'vh-flash',
      name: 'vh-flash'
    };

    this._root = document.getElementById(param['id']);
    const parent = this._root;
    const child = this._createFlash(this._swf, flashvars, params, attributes);
    parent.appendChild(child);
    this.flash = document.getElementById('vh-flash');
    this.video = this.flash;
    parent.style.position = 'relative';
    this._isLive = param['isLive'];
  }

  _createFlash(swf = defaultSwf, flashVars, params, attributes) {
    log.info('--------------------_createFlash----------');
    // const objectTag = this._createObject(swf, flashVars, params, attributes);
    // const obj = this._appendAttri('div', { innerHTML: objectTag });

    var objflash = document.createElement('object');
    objflash.setAttribute('type', 'application/x-shockwave-flash');
    objflash.setAttribute('data', swf);
    objflash.setAttribute('width', '100%');
    objflash.setAttribute('height', '100%');
    objflash.setAttribute('id', 'vh-flash');
    objflash.setAttribute('name', 'vh-flash');

    var parammovie = document.createElement('param');
    parammovie.setAttribute('name', 'movie');
    parammovie.setAttribute('value', swf);

    var paramflashvars = document.createElement('param');
    paramflashvars.setAttribute('name', 'flashvars');
    paramflashvars.setAttribute(
      'value',
      'readyFunction=onSWFReady&eventProxyFunction=onSWFEvent&errorEventProxyFunction=onSWFErrorEvent&autoplay=true&preload=none&'
    );

    var paramallowScriptAccess = document.createElement('param');
    paramallowScriptAccess.setAttribute('name', 'allowScriptAccess');
    paramallowScriptAccess.setAttribute('value', 'always');

    var paramallowNetworking = document.createElement('param');
    paramallowNetworking.setAttribute('name', 'allowNetworking');
    paramallowNetworking.setAttribute('value', 'all');

    var paramwmode = document.createElement('param');
    paramwmode.setAttribute('name', 'wmode');
    paramwmode.setAttribute('value', 'opaque');

    var parambgcolor = document.createElement('param');
    parambgcolor.setAttribute('name', 'bgcolor');
    parambgcolor.setAttribute('value', '#000000');

    objflash.appendChild(parammovie);
    objflash.appendChild(paramflashvars);
    objflash.appendChild(paramallowScriptAccess);
    objflash.appendChild(paramallowNetworking);
    objflash.appendChild(paramwmode);
    objflash.appendChild(parambgcolor);

    return objflash;
    // return obj.childNodes[0];
  }

  _appendAttri(tagName = 'div', properties = {}, attributes = {}, content) {
    const el = document.createElement(tagName);

    Object.getOwnPropertyNames(properties).forEach(function (propName) {
      const val = properties[propName];
      // See #2176
      // We originally were accepting both properties and attributes in the
      // same object, but that doesn't work so well.
      if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
        console.warn(
          'Setting attributes in the second argument of createEl()\n' +
            'has been deprecated. Use the third argument instead.\n' +
            `createEl(type, properties, attributes). Attempting to set ${propName} to ${val}.`
        );
        el.setAttribute(propName, val);

        // Handle textContent since it's not supported everywhere and we have a
        // method for it.
      } else if (propName === 'textContent') {
        this._textContent(el, val);
      } else if (el[propName] !== val) {
        el[propName] = val;
      }
    });

    Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
      el.setAttribute(attrName, attributes[attrName]);
    });

    if (content) {
      this._appendContent(el, content);
    }
    return el;
  }

  _textContent(el, text) {
    if (typeof el.textContent === 'undefined') {
      el.innerText = text;
    } else {
      el.textContent = text;
    }
    return el;
  }

  _appendContent(el, content) {
    this._normalizeContent(content).forEach(node => el.appendChild(node));
    return el;
  }

  _normalizeContent(content) {
    // First, invoke content if it is a function. If it produces an array,
    // that needs to happen before normalization.
    if (typeof content === 'function') {
      content = content();
    }

    // Next up, normalize to an array, so one or many items can be normalized,
    // filtered, and returned.
    return (Array.isArray(content) ? content : [content])
      .map(value => {
        // First, invoke value if it is a function to produce a new value,
        // which will be subsequently normalized to a Node of some kind.
        if (typeof value === 'function') {
          value = value();
        }

        if (this._isEl(value) || this._isTextNode(value)) {
          return value;
        }

        if (typeof value === 'string' && /\S/.test(value)) {
          return document.createTextNode(value);
        }
      })
      .filter(value => value);
  }

  _isEl(value) {
    return isObject(value) && value.nodeType === 1;
  }

  _isTextNode(value) {
    return isObject(value) && value.nodeType === 3;
  }

  _createObject(swf, flashVars, params, attributes) {
    const objectTag = '<object type="application/x-shockwave-flash" ';
    let flashVarsString = '';
    let paramsString = '';
    let attrsString = '';

    // Convert flash vars to string
    if (flashVars) {
      Object.getOwnPropertyNames(flashVars).forEach(function (key) {
        flashVarsString += `${key}=${flashVars[key]}&amp;`;
      });
    }

    // Add swf, flashVars, and other default params
    params = mergeOptions(
      {
        movie: swf,
        flashvars: flashVarsString,
        // Required to talk to swf
        allowScriptAccess: 'always',
        // All should be default, but having security issues.
        allowNetworking: 'all'
      },
      params
    );

    // Create param tags string
    Object.getOwnPropertyNames(params).forEach(function (key) {
      paramsString += `<param name="${key}" value="${params[key]}" />`;
    });

    attributes = mergeOptions(
      {
        // Add swf to attributes (need both for IE and Others to work)
        data: swf,
        // Default to 100% width/height
        width: '100%',
        height: '100%'
      },
      attributes
    );

    // Create Attributes string
    Object.getOwnPropertyNames(attributes).forEach(function (key) {
      attrsString += `${key}="${attributes[key]}" `;
    });

    return `${objectTag}${attrsString}>${paramsString}</object>`;
  }

  _setupAndPlayback(param) {
    this._createSWF(param);
    setTimeout(() => {
      this._waitForSWF();
    }, 100);
  }

  initFlash(param) {
    // 用户若传入了swf，就用用户的swf，否则用默认的
    if (param.isLive) {
      this._swf = param.liveOption.swf ? param.liveOption.swf : undefined;
    } else {
      this._swf = param.vodOption.swf ? param.vodOption.swf : undefined;
    }
    const videojs = {};
    videojs.Flash = {};
    videojs.Flash.onEvent = this.onSWFEvent.bind(this);
    videojs.Flash.onError = this.onSWFErrorEvent.bind(this);
    videojs.Flash.onReady = this.onSWFReady.bind(this);
    window.videojs = videojs;
    this._setupAndPlayback(param);
  }
}
